
const state = () => ({
  /**
   * This is the number of customer that is currently paying.
   * @type Number
   */
  customer: 1,

  /**
   * This is the number of customers that are going to pay.
   * @type Number
   */
  customers: 0,

  /**
   * This is the amount every customer is going to pay.
   * @type Number
   */
  amount: 0,

  /**
   * This is the amount the last customer is going to pay (+/- 0.01).
   * @type Number
   */
  lastAmount: 0,
})

const getters = {}

const mutations = {
  customer (state, v) {
    state.customer = v
  },
  nextCustomer (state) {
    state.customer += 1
  },
  customers (state, v) {
    state.customers = v
  },
  amount (state, total) {
    state.amount = parseFloat(Number(total / state.customers).toFixed(2))
    state.lastAmount = total - (state.amount * (state.customers - 1))
  },
}

const actions = {
  reset ({ commit }) {
    commit('customer', 1)
  },
  paid ({ state, commit }) {
    if (state.customer >= state.customers) {
      return
    }
    commit('nextCustomer')
    const amount = state.customer < state.customers
      ? state.amount
      : state.lastAmount
    commit('orders/payment/amountToPay', amount, { root: true })
    commit('orders/payment/paidAmount', 0, { root: true })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
